
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path: string) => {
    window.scrollTo(0, 0);
    navigate(path);
    setIsMenuOpen(false);
  };

  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div 
            className="text-2xl font-bold text-teal-600 cursor-pointer" 
            style={{ fontFamily: '"Pacifico", serif' }}
            onClick={() => handleNavigation('/')}
          >
            Castilletes
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => handleNavigation('/')}
              className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
            >
              Inicio
            </button>
            <a 
              href="#alojamiento" 
              onClick={(e) => handleSmoothScroll(e, 'alojamiento')}
              className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
            >
              Alojamiento
            </a>
            <a 
              href="#playas" 
              onClick={(e) => handleSmoothScroll(e, 'playas')}
              className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
            >
              Playas
            </a>
            <a 
              href="#galeria" 
              onClick={(e) => handleSmoothScroll(e, 'galeria')}
              className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
            >
              Galería
            </a>
            <a 
              href="#contacto" 
              onClick={(e) => handleSmoothScroll(e, 'contacto')}
              className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
            >
              Contacto
            </a>
            <button 
              onClick={() => handleNavigation('/habitaciones')}
              className="bg-teal-600 text-white px-6 py-2 rounded-full hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Reservar Ahora
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => handleNavigation('/')}
                className="text-gray-700 hover:text-teal-600 transition-colors text-left cursor-pointer"
              >
                Inicio
              </button>
              <a 
                href="#alojamiento" 
                onClick={(e) => handleSmoothScroll(e, 'alojamiento')}
                className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
              >
                Alojamiento
              </a>
              <a 
                href="#playas" 
                onClick={(e) => handleSmoothScroll(e, 'playas')}
                className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
              >
                Playas
              </a>
              <a 
                href="#galeria" 
                onClick={(e) => handleSmoothScroll(e, 'galeria')}
                className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
              >
                Galería
              </a>
              <a 
                href="#contacto" 
                onClick={(e) => handleSmoothScroll(e, 'contacto')}
                className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
              >
                Contacto
              </a>
              <button 
                onClick={() => handleNavigation('/habitaciones')}
                className="bg-teal-600 text-white px-6 py-2 rounded-full hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Reservar Ahora
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
